import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import images from "../../assets/images/constantImages";
import { UserContext } from "./UserContext";
import { useSelector } from "react-redux";


const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeSubmenuIndex, setActiveSubmenuIndex] = useState();
  const location = useLocation();
  const sidebarRef = useRef(null);
  const [subnav, setSubnav] = useState(false);
  const showSubnav = () => setSubnav(!subnav);
  const navigate = useNavigate();
  const { userData } = useContext(UserContext);
  const userType = localStorage.getItem("userType");
  const moduleAccess = JSON.parse(localStorage.getItem("moduleAccess")) || [];
  const canteenType = useSelector((state) => state.canteenType.type);

  useEffect(() => {
    if (userType === "canteenUser") {
      if (canteenType === "postpaid") {
        navigate("/mainDashboard/dashboardCt");
      } else if (canteenType === "prepaid") {
        navigate("/mainDashboard/dashboardCt");
      }
    }
  }, [canteenType]);

  const allMenus = {
    vendor: [
      {
        link: "/mainDashboard/dashboard",
        icons: images.unclickDashboard,
        activeIcon: images.dashboard,
        heading: "Dashboard",
      },
      {
        link: "/mainDashboard/booking",
        icons: images.booking,
        activeIcon: images.activebooking,
        heading: "Bookings",
      },
      {
        link: "/mainDashboard/customer",
        icons: images.customer,
        activeIcon: images.activecustomer,
        heading: "Players",
      },
      {
        link: "/mainDashboard/table",
        icons: images.tables,
        activeIcon: images.activetables,
        heading: "Tables",
      },
      {
        link: "/mainDashboard/role",
        icons: images.roleicon,
        activeIcon: images.activeroleicon,
        heading: "Roles",
      },
      {
        link: "/mainDashboard/dues",
        icons: images.dues,
        activeIcon: images.dueWhite,
        heading: "Dues",
      },
      {
        link: "/mainDashboard/staff",
        icons: images.customer,
        activeIcon: images.activecustomer,
        heading: "Staff",
      },
      {
        link: "/mainDashboard/expense",
        icons: images.expense,
        activeIcon: images.activeexpense,
        heading: "Expenses",
      },

      {
        link: "#",
        icons: images.report,
        activeIcon: images.activereport,
        heading: "Reports",
        subpath: [
          {
            name: "Collection report",
            link: "/mainDashboard/report/collectionReport",
          },
          {
            name: "Table history",
            link: "/mainDashboard/report/gameHistory",
          },
          {
            name: "Payment records",
            link: "/mainDashboard/report/paymentsRecords",
          },
        ],
      },
      {
        link: "/mainDashboard/setting",
        icons: images.setting,
        activeIcon: images.activesetting,
        heading: "Settings",
      },
    ],
    staff: [
      {
        link: "/mainDashboard/dashboard",
        icons: images.unclickDashboard,
        activeIcon: images.dashboard,
        heading: "Dashboard",
        module: "dashboard",
      },
      {
        link: "/mainDashboard/booking",
        icons: images.booking,
        activeIcon: images.activebooking,
        heading: "Bookings",
        module: "booking",
      },
      {
        link: "/mainDashboard/customer",
        icons: images.customer,
        activeIcon: images.activecustomer,
        heading: "Players",
        module: "customer",
      },
      {
        link: "/mainDashboard/table",
        icons: images.tables,
        activeIcon: images.activetables,
        heading: "Tables",
        module: "table",
      },
      {
        link: "/mainDashboard/role",
        icons: images.roleicon,
        activeIcon: images.activeroleicon,
        heading: "Roles",
        module: "role",
      },
      {
        link: "/mainDashboard/dues",
        icons: images.dues,
        activeIcon: images.dues,
        heading: "Dues",
        module: "due",
      },
      {
        link: "/mainDashboard/expense",
        icons: images.expense,
        activeIcon: images.activeexpense,
        heading: "Expenses",
        module: "expense",
      },
      {
        link: "#",
        icons: images.report,
        activeIcon: images.activereport,
        heading: "Reports",
        subpath: [
          {
            name: "Collection report",
            link: "/mainDashboard/report/collectionReport",
          },
          {
            name: "Table history",
            link: "/mainDashboard/report/gameHistory",
          },
        ],
        module: "report",
      },
      {
        link: "/mainDashboard/setting",
        icons: images.setting,
        activeIcon: images.activesetting,
        heading: "Settings",
        module: "setting",
      },
    ],
    canteenUser: [
      {
        link: "/mainDashboard/dashboardCt",
        icons: images.unclickDashboard,
        activeIcon: images.dashboard,
        heading: "Dashboard",
      },
      {
        link: "/mainDashboard/addOrder",
        icons: images.defaultOrder,
        activeIcon: images.activeOrder,
        heading: "Orders",
      },
      {
        link: "/mainDashboard/additems",
        icons: images.defaultItem,
        activeIcon: images.activeItem,
        heading: "Items",
      },

      {
        link: "/mainDashboard/StockList",
        icons: images.defaultStock,
        activeIcon: images.activeStock,
        heading: "Stock",
      },
      {
        link: "/mainDashboard/addcombo",
        icons: images.defaultItem,
        activeIcon: images.activeItem,
        heading: "Combo Offers",
      },
      {
        link: "#",
        icons: images.report,
        activeIcon: images.activereport,
        heading: "Reports",
        subpath: [
          {
            name: "Collection Report",
            link: "/mainDashboard/report/collectionReports",
          },
          {
            name: "Sale Report",
            link: "/mainDashboard/report/salesReport",
          },
        ],
      },
      {
        link: "/mainDashboard/canteenexpense",
        icons: images.expense,
        activeIcon: images.activeexpense,
        heading: "Expenses",
      },
      {
        link: "/mainDashboard/menusList",
        icons: images.expense,
        activeIcon: images.activeexpense,
        heading: "Menus",
      },
    ],
  };

  // Filter staff menu based on module access
  const filteredStaffMenu = [
    ...allMenus.staff.filter((menu) => moduleAccess.includes(menu.module)),
    allMenus.staff.find((menu) => menu.heading === "Settings"),
  ];

  const canteenMenus = allMenus.canteenUser.filter((menu) => {
    if (canteenType === "prepaid") {
      return !["Menus"].includes(menu.heading);
    }
    if (canteenType === "postpaid") {
      return ["Dashboard", "Orders", "Menus"].includes(menu.heading);
    }
    return true;
  });
  const sidebarItems =
    userType === "vendor"
      ? allMenus.vendor
      : userType === "staff"
        ? filteredStaffMenu
        : userType === "canteenUser"
          ? canteenMenus
          : allMenus.vendor;

  useEffect(() => {
    const currentIndex = sidebarItems.findIndex((item) =>
      location.pathname.startsWith(item.link)
    );
    setActiveIndex(currentIndex !== -1 ? currentIndex : null);

    if (location.pathname.startsWith("/mainDashboard/report")) {
      setSubnav(true);
      const reportIndex = sidebarItems.findIndex(
        (item) => item.heading === "Reports"
      );
      if (reportIndex !== -1) {
        setActiveIndex(reportIndex);
        const subIndex = sidebarItems[reportIndex]?.subpath?.findIndex((sub) =>
          location.pathname.startsWith(sub.link)
        );
        setActiveSubmenuIndex(subIndex !== -1 ? subIndex : 0);
      }
    }
  }, [location.pathname]);

  const handleToggleSubnav = () => {
    setSubnav((prev) => !prev);
  };

  const handleColorChange = (index, subIndex) => {
    setActiveIndex(index);
    setActiveSubmenuIndex(subIndex);
    if (sidebarItems[index]?.heading !== "Reports") {
      setSubnav(false);
    }
    setSidebarOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSidebarOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div
        ref={sidebarRef}
        className={`h-screen w-[80%] xs:w-[60%] sm:w-[40%] md:w-[35%] sx:absolute z-40 lg:z-0 bg-white lg:w-[17%] xl:w-1/6 overflow-y-auto vertical lg:relative lg:block border-2 border-r-black/5 ${sidebarOpen ? "block" : "hidden"
          }`}
      >
        <div className="flex justify-center my-6">
          <img
            src={
              userData.store_logo
                ? `https://headquater.pixoatic.com/${userData.store_logo}`
                : images.logo
            }
            alt="store logo"
            className="w-[152px] lg:w-[140px] xl:w-[152px] h-[64px]"
          />
        </div>
        <div className="flex flex-col gap-[10px]">
          {sidebarItems.map((values, index) => (
            <div key={index}>
              <ul
                className={`flex ${activeIndex === index
                  ? "w-1 h-auto rounded-r-lg"
                  : "border-l-2 border-transparent"
                  }`}
              >
                <Link
                  to={values.link}
                  onClick={() => {
                    if (values.subpath) {
                      handleToggleSubnav();
                      setActiveIndex(index);
                    } else {
                      handleColorChange(index, null);
                      navigate(values.link);
                    }
                  }}
                >
                  <li
                    className={`transition-all duration-75 flex ml-4 lg:ml-2 xl:ml-4 gap-3 w-[180px] lg:w-[140px] xl:w-[180px] px-4 py-3 rounded-lg ${activeIndex === index
                      ? "bg-green text-white"
                      : "bg-transparent text-G500"
                      }`}
                  >
                    <p>
                      <img
                        src={
                          activeIndex === index
                            ? values.activeIcon
                            : values.icons
                        }
                        alt="icon"
                        className="w-6 h-6"
                      />
                    </p>
                    <h1 className="font-medium text-base lg:text-sm xl:text-base">
                      {values.heading}
                    </h1>
                  </li>
                </Link>
              </ul>

              {values.subpath && subnav && activeIndex === index && (
                <ul className="pl-14 lg:pl-11 xl:pl-14 mt-3">
                  {values.subpath.map((data, subIndex) => (
                    <li
                      key={subIndex}
                      className={`text-sm lg:text-[12px] xl:text-sm list-disc my-2 ${activeSubmenuIndex === subIndex
                        ? "text-green"
                        : "text-G500"
                        }`}
                      onClick={() => handleColorChange(index, subIndex)}
                    >
                      <Link to={data.link}>{data.name}</Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sidebar;